module.exports = __webpack_public_path__ + "static/media/empty-mirchi.5b8a10a1.svg";